import { InjectionToken, Type } from '@angular/core';

import { NbToastrConfig } from '@nebular/theme';

import { BaseToastComponent } from '../../toast/base-toast.component';

export type TRootToastConfig = {
  containerClass?: string;
  defaultStatusIcons?: {
    info?: string;
    warning?: string;
    danger?: string;
    success?: string;
  };
} & Omit<ToastConfig, 'component'>;

export const TOASTR_CONFIG = new InjectionToken<TRootToastConfig>('Default toaster config');

export class ToastConfig extends NbToastrConfig {
  public component: Type<any> = BaseToastComponent;

  constructor(data: Partial<NbToastrConfig & { component: Type<any> }>) {
    super(data);

    Object.assign(this, data);

    if (!data.component) {
      this.component = BaseToastComponent;
    }
  }
}
